import React, { ChangeEvent, useEffect, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormCheck,
  CFormInput,
  CFormSelect,
  CRow,
} from '@coreui/react-pro'
import { languages } from '../../../../../libs/languages'
import { useStore } from 'effector-react'
import {
  $offersByLang,
  $webBannerGroup,
  offersByLangMounted,
  setWebBannerGroupForm,
  submitCreateWebBannerGroup,
} from './model'

export const CreateWebBannerGroup: React.FC = () => {
  const [validated, setValidated] = useState(false)

  const webBannerGroup = useStore($webBannerGroup)
  const offersByLang = useStore($offersByLang)

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else {
      value = event.currentTarget.value
    }

    setWebBannerGroupForm({
      ...webBannerGroup,
      [event.currentTarget.name]: value,
    })
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget

    if (!form.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      submitCreateWebBannerGroup({
        ...webBannerGroup,
        offerId: Number(webBannerGroup.offerId),
      })
      event.preventDefault()
      event.stopPropagation()
    }
    setValidated(true)
  }

  useEffect(() => {
    offersByLangMounted({ lang: webBannerGroup.lang })
  }, [webBannerGroup.lang])

  useEffect(() => {
    if (offersByLang.length) {
      setWebBannerGroupForm({
        ...webBannerGroup,
        offerId: offersByLang[0].id,
      })
    }
  }, [offersByLang])

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Create website banner media group</strong>
      </CCardHeader>
      <CCardBody>
        <CForm noValidate validated={validated} onSubmit={handleSubmit}>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormInput
                type="text"
                name="title"
                value={webBannerGroup.title}
                onChange={handleChange}
                label="Name"
                minLength={3}
                maxLength={30}
                required
              />
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormSelect
                label="Language"
                name="lang"
                value={webBannerGroup.lang}
                onChange={handleChange}
              >
                {languages.map((language) => (
                  <option value={language.value}>{language.label}</option>
                ))}
              </CFormSelect>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormSelect
                label="Offer"
                name="offerId"
                value={webBannerGroup.offerId}
                disabled={offersByLang.length === 0}
                onChange={handleChange}
              >
                {offersByLang?.map((offer) => (
                  <option value={offer.id}>{offer.title}</option>
                ))}
              </CFormSelect>
            </CCol>
          </CRow>
          <CRow className="mb-3">
            <CCol sm={4}>
              <CFormCheck
                name="isVisible"
                checked={webBannerGroup.isVisible}
                onChange={handleChange}
                label="Active"
              />
            </CCol>
          </CRow>
          <CButton className="mb-3" type="submit">
            Save
          </CButton>
        </CForm>
      </CCardBody>
    </CCard>
  )
}
